module.exports = __webpack_public_path__ + "static/media/product3.a0e40011.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product3.jpg
// module id = 1314
// module chunks = 0